import pick from 'lodash/pick'
import { filterValidStyles } from './elementUtils'

const getElementBackgroundStyle = (background) => {
  const backgroundStyle = filterValidStyles(pick(background,
    [
      'backgroundColor',
      'objectFit',
      'backgroundSize',
      'backgroundImageStyle',
      'backgroundPositionX',
      'backgroundPositionY',
    ],
  ))
  const backgroundImage = background.backgroundImage ?
    { backgroundImage: `url(${background.backgroundImage})` } : {}
  const backgroundImageStyle = (() => {
    switch (background.backgroundImageStyle) {
      case 'Fill':
        return {
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: background.backgroundPositionX,
          backgroundPositionY: background.backgroundPositionY,
        }
      case 'Fit':
        return {
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: background.backgroundPositionX,
          backgroundPositionY: background.backgroundPositionY,
        }
      case 'Stretch':
        return {
          backgroundSize: '100% 100%',
          backgroundRepeat: '',
          backgroundPositionX: '',
          backgroundPositionY: '',
        }
      case 'Tile':
        return {
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat',
          backgroundPositionX: '',
          backgroundPositionY: '',
        }
      default:
        return {}
    }
  })()

  return {
    ...backgroundImage,
    ...backgroundStyle,
    ...backgroundImageStyle,
  }
}

export default getElementBackgroundStyle



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/elementBackgroundStyle.js